export * from './InputLabel';
